import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faUsers,
  faTableList,
  faMagnifyingGlass,
  faUserPlus,
  faPhone,
  faLocationDot,
  faRightFromBracket,
  faChevronLeft,
  faChevronRight,
  faHandHoldingDollar,
  faCashRegister,
  faTrashCan,
  faEye,
  faEyeSlash,
  faPlus,
  faPersonWalking,
  faBars,
  faXmark,
  faScaleBalanced,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";

// ------------------------------------------------------------
// Iconos del sistema, todos de Font Awesome.
//
// Vienen del paquete, no de un enlace a internet: quedan dentro del
// archivo que se sube al servidor, así que cargan aunque no haya red
// y no se descarga la fuente completa de iconos, solo los que se usan.
//
// Cada icono se exporta con su propio nombre para que las pantallas no
// tengan que saber de dónde salen. Cambiar un icono se hace aquí.
// ------------------------------------------------------------

const Icono = ({ icono, ...resto }) => <FontAwesomeIcon icon={icono} {...resto} />;

// --- Acciones sobre registros ---
export const EditIcon = () => <Icono icono={faPenToSquare} />;
export const TrashIcon = () => <Icono icono={faTrashCan} />;

// --- Navegación ---
export const UserGroupIcon = () => <Icono icono={faUsers} />;
export const ChartIcon = () => <Icono icono={faTableList} />;
export const LogoutIcon = () => <Icono icono={faRightFromBracket} size="lg" />;
export const BackIcon = () => <Icono icono={faChevronLeft} />;
export const ForwardIcon = () => <Icono icono={faChevronRight} />;
export const MenuIcon = () => <Icono icono={faBars} size="lg" />;
export const CloseIcon = () => <Icono icono={faXmark} size="lg" />;
export const ScaleIcon = () => <Icono icono={faScaleBalanced} />;
export const ShareIcon = () => <Icono icono={faShareNodes} />;

// --- Clientes ---
export const SearchIcon = () => <Icono icono={faMagnifyingGlass} />;
export const UserPlusIcon = () => <Icono icono={faUserPlus} />;
export const PhoneIcon = () => <Icono icono={faPhone} />;
export const PinIcon = () => <Icono icono={faLocationDot} />;

// --- Movimientos ---
export const PlusIcon = () => <Icono icono={faPlus} />;
export const PlusSquareIcon = () => <Icono icono={faHandHoldingDollar} />;
export const DollarIcon = () => <Icono icono={faCashRegister} />;
export const WalkIcon = () => <Icono icono={faPersonWalking} />;

// --- Mostrar u ocultar montos ---
export const EyeIcon = () => <Icono icono={faEye} />;
export const EyeOffIcon = () => <Icono icono={faEyeSlash} />;
